import React from 'react'
import PropTypes from 'prop-types'
import LoadingOverlay from 'components/shared/loader/overlay'
import BodyClass from 'components/shared/body-class'

const View = ({ children, theme, loading, customClass }) => {
  const className = `flex ${customClass}`
  return (
    <LoadingOverlay loading={loading}>
      <BodyClass className={theme ? `bg-${theme}` : ''} />
      <div className={className}>{children}</div>
    </LoadingOverlay>
  )
}

View.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.string,
  loading: PropTypes.bool,
  customClass: PropTypes.string,
}

export default View
